import React, { useRef, lazy } from 'react';
export function BeforeAfterCarousel() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -360 : 360,
        behavior: 'smooth'
      });
    }
  };
  const slides = [{
    name: 'Silvia R.',
    location: 'Buenos Aires',
    image: 'https://cdn.magicpatterns.com/uploads/txBxisJ1GFWpMT9vH25dg8/Captura_de_pantalla_2026-05-25_144008.png',
    quote: 'Bajé 5 kilos la primera semana y me desinflé un montón. La ropa que tenía guardada hace dos años me volvió a entrar. Y todo sin pasar hambre.'
  }, {
    name: 'Graciela M.',
    location: 'Córdoba',
    image: 'https://cdn.magicpatterns.com/uploads/bwKzJvnXeB19AHgrhsmW2m/Captura_de_pantalla_2026-05-25_144000.png',
    quote: 'La panza no se me iba con nada, había probado de todo. Cambié la forma de comer como dice el método y a los pocos días ya me sentía otra.'
  }, {
    name: 'Patricia L.',
    location: 'Rosario',
    image: 'https://cdn.magicpatterns.com/uploads/f7HDdVTHn3Gt8dfcSAeiXc/Captura_de_pantalla_2026-05-25_143955.png',
    quote: 'Mil dietas y siempre volvía a engordar. Por fin entendí por qué mi cuerpo no respondía después de los 40. Bajé tranquila y esta vez lo mantuve.'
  }];
  return <div className="bg-brand-ink py-16 px-6" data-id="element-18">
      <div className="max-w-[960px] mx-auto" data-id="element-19">
        <span className="block text-[11px] font-bold tracking-[3px] uppercase text-brand-green text-center mb-2.5" data-id="element-20">
          ❤️ Resultados reales
        </span>
        <h2 className="font-display text-[22px] sm:text-[3.5vw] md:text-[38px] text-center text-white mb-2 uppercase" data-id="element-21">
          Mirá lo que están conquistando
        </h2>
        <div className="green-divider" data-id="element-22"></div>

        <div className="relative" data-id="element-23">
          <div ref={scrollRef} className="flex gap-5 overflow-x-auto pb-3 scroll-smooth scrollbar-thin scrollbar-thumb-brand-green scrollbar-track-[#222]" style={{
          scrollbarWidth: 'thin',
          scrollbarColor: '#00c853 #222'
        }} data-id="element-24">
            {slides.map((slide, i) => <div key={i} className="flex-none w-[320px] relative rounded-xl overflow-hidden bg-brand-ink border border-brand-border" data-id="element-25">
                <div className="w-full h-[380px] bg-[#1a1a1a] overflow-hidden" data-id="element-26">
                  <img src={slide.image} alt={`Antes y después de ${slide.name}`} width="320" height="380" className="w-full h-full object-cover" loading="lazy" data-id="element-27" />
                </div>
                <div className="flex" data-id="element-28">
                  <span className="flex-1 text-center py-2.5 font-display text-sm font-bold tracking-[1px] uppercase bg-brand-red/85 text-white" data-id="element-29">
                    ANTES
                  </span>
                  <span className="flex-1 text-center py-2.5 font-display text-sm font-bold tracking-[1px] uppercase bg-brand-green/85 text-white" data-id="element-30">
                    DESPUÉS
                  </span>
                </div>

                <div className="p-4 text-left border-t border-brand-border" data-id="element-31">
                  <div className="text-[#f5b50a] text-[15px] tracking-[2px] mb-1.5 leading-none" data-id="element-32">
                    ★★★★★
                  </div>
                  <p className="text-[13px] text-white/80 italic leading-[1.5] mb-2" data-id="element-33">
                    "{slide.quote}"
                  </p>
                  <p className="font-display text-[12px] text-brand-muted tracking-[1px]" data-id="element-34">
                    📍 {slide.name} — {slide.location}
                  </p>
                </div>
              </div>)}
          </div>

          <div className="flex justify-center gap-3 mt-4" data-id="element-35">
            <button onClick={() => scroll('left')} className="bg-white/5 border border-white/15 text-white w-9 h-9 rounded-full flex items-center justify-center text-lg hover:bg-brand-green/40 transition-colors" data-id="element-36">
              &#8249;
            </button>
            <button onClick={() => scroll('right')} className="bg-white/5 border border-white/15 text-white w-9 h-9 rounded-full flex items-center justify-center text-lg hover:bg-brand-green/40 transition-colors" data-id="element-37">
              &#8250;
            </button>
          </div>
        </div>
      </div>
    </div>;
}